import React from 'react';
import { spacing } from '../common';
const base = {
    width: spacing(2),
    height: spacing(2),
    borderRadius: '50%',
    backgroundColor: 'white',
};
const iconStyle = Object.assign(Object.assign({}, base), { boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)', backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))' });
const checkedIconStyle = Object.assign(Object.assign({}, base), { display: 'block', boxShadow: 'inset 0 0 0 1.3px currentColor, inset 0 -1px 0 rgba(16,22,26,.1)', backgroundImage: 'radial-gradient(currentColor, currentColor 40%, transparent 46%)' });
export const MuiRadioIcon = React.createElement("span", { style: iconStyle });
export const MuiRadioCheckedIcon = React.createElement("span", { style: checkedIconStyle });
//# sourceMappingURL=MuiRadio.js.map